import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { ProductLicenseResource } from '../../../../../Types';
import { selectable, selectableOption, selectedInLearningCollection } from '../../DateSelection';
import Store from '../Store';
import { ExperienceResource } from '../Types';
import DateCheckbox from './DateCheckbox';
import LearningCollectionEditStore from '../../../../Edit/Store';

interface Props {
  learningCollectionStore: LearningCollectionEditStore;
  resource: ExperienceResource;
  store: Store;
  productLicense: ProductLicenseResource;
}

function SelectableDate({ resource, store, productLicense, learningCollectionStore }: Props) {
  return (
    <div className="max-h-60 overflow-y-auto">
      {resource.payload.programInstanceOptions.scheduled.map((scheduledOption) =>
        selectableOption(scheduledOption, productLicense)
          .orElse(() => selectedInLearningCollection(learningCollectionStore, scheduledOption))
          .map((option) => (
            <DateCheckbox
              scheduledOption={option}
              store={store}
              selectable={selectable(option, productLicense)}
            />
          ))
          .getOrElse(emptyFragment),
      )}
    </div>
  );
}

export default observer(SelectableDate);
